import { render, staticRenderFns } from "./performList.vue?vue&type=template&id=c0183fec&scoped=true&"
import script from "./performList.vue?vue&type=script&lang=js&"
export * from "./performList.vue?vue&type=script&lang=js&"
import style0 from "./performList.vue?vue&type=style&index=0&id=c0183fec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0183fec",
  null
  
)

export default component.exports